import makeStyles from '@mui/styles/makeStyles';

const muiTabsStyles = makeStyles({
  tabs: {
    width: '100%', // Ensure the Tabs container spans the full width
    borderBottom: '1px solid #ccc', // Add a small border line underneath all tabs
  },
  tab: {
    flex: 1, // Make each Tab take up an equal portion of the width
    maxWidth: 'none', // Remove the default max-width restriction
    textAlign: 'center', // Center the text inside the tab
    padding: '15px', // Add 15px padding all around
    fontSize: '1rem', // Set font size to 1rem
    fontWeight: 'normal', // Default font weight for inactive tabs
    textTransform: 'none', // Remove uppercase transformation
    color: 'var(--alt-black)',
    '&.Mui-selected': {
      fontWeight: 'bold', // Make the active tab bold
    },
    '&.Mui-selected:focus-visible': {
      color: 'white', // Change text color to white when selected and focused
    },
    '&:hover': {
      boxShadow: 'none !important', // Use !important to override global styles
    },
  },
});

export default muiTabsStyles;